import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { generalClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import { useSaveTag } from './_requests/saveTag'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Tags($search: String, $page: Int, $filter: TagFilter) {
    tags(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      type
      color
    }
  }
`

export const useTagLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: generalClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'tags']))
  }
}

/**
 * `allowCreate` controla o atalho "Criar novo: <nome>" do Select (herdado do uso original desta
 * tag genérica para tags de pergunta de checklist, que não têm cor). Para tag de atividade
 * (`type="service_orders"`), o cadastro tem cor obrigatória, então os pontos de atribuição da tag
 * (formulário/lista/kanban de atividades, condições/ações de automação) passam `allowCreate={false}`
 * e direcionam para a tela de cadastro (`/tags`), que é a única forma de criar uma tag com cor.
 */
const TagSelect = ({ onChange, value, type, allowCreate = true, ...props }) => {
  const getOptions = useTagLoader({ types: type })

  const [onCreate] = useSaveTag(type, onChange, value)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      onCreate={allowCreate ? onCreate : undefined}
      {...props}
    />
  )
}

export default TagSelect
